import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, getStoredLanguage } from '../translations/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getStoredLanguage());
  
  useEffect(() => {
    // Guardar idioma en localStorage cuando cambie
    localStorage.setItem('app_language', language);
  }, [language]);
  
  const changeLanguage = (newLanguage) => {
    if (newLanguage === 'es' || newLanguage === 'en') {
      setLanguage(newLanguage);
    }
  };
  
  const t = (key, fallback = '') => {
    const keys = key.split('.');
    let result = translations[language];
    
    for (const k of keys) {
      result = result?.[k];
      if (result === undefined) break;
    }
    
    return result || fallback || key;
  };
  
  // Función para obtener todo un objeto de traducciones
  const getTranslations = (key = '') => {
    if (!key) return translations[language];
    
    const keys = key.split('.');
    let result = translations[language];
    
    for (const k of keys) {
      result = result?.[k];
      if (result === undefined) break;
    }
    
    return result || {};
  };
  
  const value = {
    language,
    changeLanguage,
    t,
    getTranslations,
    isSpanish: language === 'es',
    isEnglish: language === 'en'
  };
  
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}; 